/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flex, Alert } from 'antd';
import agbColors from 'constants/Colors/agbColors';
import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { useLanguage } from 'hooks/Language/useLanguage';

interface InputFormBoxProps {
  title?: string | React.ReactNode;
  onSelectRecipient?: () => void;
  displaySelectRecipient?: boolean;
  formItems?: React.ReactNode[];
  select?: any[];
  onHandleCloseSelectContact?: () => void;
  BackButton?: React.ReactNode;
  showBackButton?: boolean;
}

const InputFormBox: React.FC<InputFormBoxProps> = ({
  title,
  onSelectRecipient,
  displaySelectRecipient = false,
  formItems,
  select,
  BackButton,
  showBackButton = false,
}) => {
  const { translate } = useLanguage();
  return (
    <Flex vertical>
      <Flex justify="space-between" style={{ width: '100%' }}>
        <span className="medium-text">{title}</span>
      </Flex>
      <Flex gap="large" vertical>
        {select?.map((item, index) => <div key={index}>{item}</div>)}
        {displaySelectRecipient && (
          <Alert
            message={
              <span className="large-margin-left">
                {translate('Select a beneficiary')}
              </span>
            }
            onClick={onSelectRecipient}
            type="warning"
            style={{ cursor: 'pointer' }}
            action={
              <Flex vertical>
                <DownOutlined
                  style={{ color: agbColors.greyColor }}
                />
              </Flex>
            }
          />
        )}

        {formItems?.map((item: React.ReactNode) => item)}
      </Flex>
    </Flex>
  );
};

export default InputFormBox;
